import useIsAdmin from '../../../../WorkspaceAdmin/useIsAdmin';

/**
 * This hook determines the type of request based on the presence of workspaceId and groupId.
 * It returns 'group' if groupId is present, 'workspace' if workspaceId is present, 'workspaces' if the user is an admin, and 'user' otherwise.
 *
 * Usually there a different request made
 * @param workspaceId - The ID of the workspace, if applicable.
 * @param groupId - The ID of the group, if applicable.
 * @returns A string representing the type of request: 'group', 'workspace', 'workspaces', or 'user'.
 */
function useTypeRequest(
  workspaceId: string | undefined,
  groupId: string | undefined
) {
  const isAdmin = useIsAdmin();
  return groupId
    ? 'group'
    : workspaceId
    ? 'workspace'
    : isAdmin
    ? 'workspaces'
    : 'user';
}

export default useTypeRequest;
